import { ActionIcon } from '@mantine/core';
import { IconSun, IconMoonStars } from '@tabler/icons-react';
import styles from './ThemeToggle.module.scss';
import { FC } from 'react';

interface ThemeToggleProps {
  onToggle: () => void;
  isDark: boolean;
}

export const ThemeToggle: FC<ThemeToggleProps> = ({ onToggle, isDark }) => {
  return (
    <ActionIcon
      variant={isDark ? 'light' : 'subtle'}
      color={isDark ? 'yellow' : 'blue'}
      onClick={onToggle}
      title="Toggle color scheme"
      className={styles.themeToggle}
      data-dark={isDark || undefined}
      size="lg"
    >
      {isDark ? <IconSun size={18} stroke={1.5} /> : <IconMoonStars size={18} stroke={1.5} />}
    </ActionIcon>
  );
};
